import ActionItemContainer from '@/app/components/UI/ActionItemContainer/ActionItemContainer'
import {
    createMessage,
    getMessage,
    reactionMessage,
    removeMessage,
    setMessagePageNum,
    updateMessageList,
} from '@/app/redux/actions/activity-execution'
import {
    ExecutionMessage,
    NEW_ACTIVITY_EXECUTION_NAMESPACE,
} from '@/app/redux/reducers/activity-execution'
import {
    CreateMessageBody,
    GetMessageParams,
    // ReactionOperation,
} from '@Techedge/digitalportal-shared'
import { Fragment, useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { LuxIconSpinner } from '@lux/wardrobe-lib'
import Message from './Message/Message'
import MessageForm from './MessageForm/MessageForm'
import './Messaging.scss'
import DialogStoreList from '../../UI/Dialogs/DialogStoreList/DialogStoreList'

const Messaging = (props: any) => {
    const {
        messageList,
        updateMessageList,
        onRemove,
        createMessage,
        getMessage,
        projectDetails,
        isMessageListLoading,
        reactionMessage,
        messagePageNum,
        totalMessage,
        setMessagePageNum,
        isMessageCreateLoading,
    } = props
    const componentClass = 'smart-modals-new-activity-execution-messaging'
    const intl = useIntl()
    const [showAddLink, setShowAddLink] = useState(false)
    const [showStoreDialog, setShowStoreDialog] = useState(false)
    const [storesDialog, setStoresDialog] = useState([])

    const loadMoreLabel = useMemo(
        () =>
            intl.formatMessage({
                id: 'forum.load.more',
                defaultMessage: 'Load more',
            }),
        [intl]
    )

    useEffect(() => {
        setMessagePageNum(1)
        // getMessage({
        //     projectId: projectDetails._id,
        //     isDetail: true,
        //     isLoadMore: false,
        //     pageNum: 1
        // })
    }, [])

    const onLoadMore = () => {
        let pageNum = messagePageNum + 1
        setMessagePageNum(messagePageNum + 1)
        getMessage({
            projectId: projectDetails._id,
            isDetail: true,
            isLoadMore: true,
            pageNum: pageNum
        })
    }

    const onAddMessage = () => {
        // setShowAddLink(true)
        updateMessageList(-1, {
            author: {
                name: '',
                lastname: '',
                nickname: '',
            },
            creationDate: new Date(),
            reason: null,
            reactions: {
                typeList: [],
                total: 0,
            },
            commentsList: [],
            stores: projectDetails?.storesList,
            storeList: projectDetails?.storesList,
            message: null,
            attachmentList: [],
            isEdit: true,
        })
    }

    const onReduce = (index: number, message) => {
        // setShowAddLink(false)
        if (!message.isEdit) onRemove(index)
        delete message.isEdit
        updateMessageList(index, message)
    }

    const onMessageSave = (index: number, form) => {
        if (form.hasOwnProperty('isEdit')) setShowAddLink(false)
        updateMessageList(index, form)
    }

    const onCreateMessage = (index: number) => {
        const form = messageList[index]
        // delete form.isEdit
        // updateMessageList(index, form)
        createMessage(
            {
                reason: form.reason,
                text: form.message,
                isGif: false,
                attachmentIds: form.attachmentList.map((a) => a._id || a.id),
                reference: {
                    projectId: projectDetails._id,
                    storeIdList: form.stores.map((s) => s.storeId),
                },
            },
            form.id,
            index
        )
    }

    return (
        <div className={componentClass}>
            {!messageList.length && isMessageListLoading && <LuxIconSpinner />}
            {!messageList.length && !isMessageListLoading && (
                <div className={`${componentClass}__empty-message text`}>
                    {intl.formatMessage({
                        id: 'modals.new.activity.execution.messaging.empty',
                        defaultMessage: 'There are no messages in this activity yet.',
                    })}
                </div>
            )}
            {messageList.length > 0 && (
                <div className={`${componentClass}__empty-message text`}>
                    {intl.formatMessage({
                        id: 'modals.new.activity.execution.messaging.not.empty',
                        defaultMessage: 'Messages for this task:',
                    })}{' '}
                    {totalMessage}
                </div>
            )}
            <ActionItemContainer
                hasItems={messageList.length > 0}
                showAddLink={showAddLink}
                linkOnTop
                onAddItem={() => onAddMessage()}
                title={intl.formatMessage({
                    id: 'modals.new.activity.execution.messaging.add',
                    defaultMessage: 'Add message',
                })}>
                {messageList.map((message, index) => (
                    <Fragment key={message.id || index}>
                        {!message.isEdit && (
                            <Message
                                message={message}
                                projectId={projectDetails?._id}
                                updateTotalReactions={(type) => {
                                    reactionMessage(
                                        {
                                            reaction: type,
                                            reactionOperation: 'add',
                                            reference: {
                                                projectId: projectDetails?._id,
                                                storeIdList: message.stores.map((s) => s.storeId),
                                            },
                                        },
                                        message.id,
                                        message.reactions.userReaction,
                                        type
                                    )
                                }}
                                onAddComment={(form) => {
                                    updateMessageList(index, form)
                                }}
                                onMarkAsRead={() => updateMessageList(index, { isUnread: false })}
                                onEdit={() => updateMessageList(index, { isEdit: true })}
                                onStoresList={(stores) => {
                                    setStoresDialog(stores)
                                    setShowStoreDialog(true)
                                }}
                            />
                        )}
                        {message.isEdit && (
                            <MessageForm
                                form={message}
                                stores={message.storeList}
                                title={intl.formatMessage({
                                    id: 'modals.new.activity.execution.messaging.title',
                                    defaultMessage: 'Add message',
                                })}
                                onMessageSave={(form) => onMessageSave(index, form)}
                                onReduce={() => onReduce(index, message)}
                                onCreateMessage={() => onCreateMessage(index)}
                            />
                        )}
                    </Fragment>
                ))}
                {isMessageCreateLoading && <LuxIconSpinner />}
                {messageList.length < totalMessage &&
                    !isMessageListLoading &&
                    !isMessageCreateLoading && (
                        <div className={`${componentClass}__load-more link`} onClick={onLoadMore}>
                            {loadMoreLabel}
                        </div>
                    )}
                {messageList.length > 0 && isMessageListLoading && !isMessageCreateLoading && (
                    <LuxIconSpinner />
                )}
                <DialogStoreList
                    dialogVisible={showStoreDialog}
                    onHide={() => setShowStoreDialog(false)}
                    storesList={storesDialog}
                />
            </ActionItemContainer>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    messageList: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].messageList,
    isMessageListLoading: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].isMessageListLoading,
    isMessageCreateLoading: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].isMessageCreateLoading,
    totalMessage: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].totalMessage,
    messagePageNum: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].messagePageNum,
    projectDetails: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].projectDetails,
})

const mapDispatchToProps = (dispatch: any) => ({
    updateMessageList: (index: number, message: Partial<ExecutionMessage>) =>
        dispatch(updateMessageList(index, message)),
    onRemove: (index: number) => dispatch(removeMessage(index)),
    createMessage: (body: CreateMessageBody, id?: string, index?: number) =>
        dispatch(createMessage(body, id, index)),
    getMessage: (params: GetMessageParams) => dispatch(getMessage(params)),
    reactionMessage: (
        body: Partial<CreateMessageBody>,
        id: string,
        userReaction: string,
        reaction?: string
    ) => dispatch(reactionMessage(body, id, userReaction, reaction)),
    setMessagePageNum: (messagePageNum: number) => dispatch(setMessagePageNum(messagePageNum)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Messaging)
